"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var ToggleButton_1 = __importDefault(require("@mui/material/ToggleButton"));
var ToggleButtonGroup_1 = __importDefault(require("@mui/material/ToggleButtonGroup"));
var Preact = __importStar(require("preact"));
var Component = function (p) {
    var _a;
    return (Preact.h(ToggleButtonGroup_1.default, { value: p.value, exclusive: true, onChange: function (_, value) { return value !== null && p.handleChange(value); }, size: p.size, color: "primary", disabled: (_a = p.disabled) !== null && _a !== void 0 ? _a : false, sx: __assign(__assign({}, p.sx), { '&.MuiToggleButtonGroup-root': {
                height: '36px',
            } }) }, p.options.map(function (option) {
        var _a, _b;
        return (Preact.h(ToggleButton_1.default, { "aria-label": option.toString(), value: option, sx: __assign({ borderColor: 'primary.light', ':disabled': { borderColor: 'primary.light' }, color: 'primary.main', textTransform: 'capitalize' }, p.buttonSx), disabled: (_b = (_a = p.disableOption) === null || _a === void 0 ? void 0 : _a.call(p, option)) !== null && _b !== void 0 ? _b : false, color: "primary" }, option.toString()));
    })));
};
exports.Component = Component;
